goog.provide("shadow.js.shim.module$$mui$material$Snackbar$default");
shadow.js.shim.module$$mui$material$Snackbar$default = shadow.js.shim.module$$mui$material$Snackbar.default;
